import Vue from "vue";

import {
  required,
  required_if,
  email,
  min,
  max,
  length,
  confirmed,
  image,
  size,
  min_value
} from "vee-validate/dist/rules";

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
  setInteractionMode
} from "vee-validate";

import it from "vee-validate/dist/locale/it.json";

localize("it", it);

extend("required", required);
extend("required_if", required_if);
extend("email", email);
extend("min", min);
extend("min_value", min_value);
extend("max", max);
extend("length", length);
extend("confirmed", confirmed);
extend("image", image);
extend("size", size);

extend("required_if_not", {
  ...required_if,
  validate: (value, args) => {
    let target_value = args.target;
    return Boolean(target_value || value);
  },
  message: "Il campo {_field_} è richiesto"
});

setInteractionMode("aggressive");
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
